import { createSlice } from "@reduxjs/toolkit";

export const GroupsSlice = createSlice({
  name: "groups",
  initialState: {
    init: false,
    groups: [],
    groupInvitations: [],
    currentGroup: null,
    seletedModal: null,
  },
  reducers: {
    setData: (state, action) => {
      const { groups, groupInvitations } = action.payload;
      state.groups = groups;
      state.groupInvitations = groupInvitations;
      state.init = true;
    },
    setCurrentGroup: (state, action) => {
      state.currentGroup = action.payload;
    },
    setSelectedModal: (state, action) => {
      state.selectedModal = action.payload;
    },
    addGroup: (state, action) => {
      state.groups.push(action.payload);
    },
    updateGroup: (state, action) => {
      const { id, ...rest } = action.payload;
      const index = state.groups.findIndex((group) => group.id === id);
      if (index !== -1) {
        state.groups[index] = { ...state.groups[index], ...rest };
      }
    },
    removeGroupInvitation: (state, action) => {
      const { id } = action.payload;
      const index = state.groupInvitations.findIndex(
        (invitation) => invitation.id === id
      );
      if (index !== -1) {
        state.groupInvitations.splice(index, 1);
      }
    },
  },
});

export const {
  setData,
  setCurrentGroup,
  setSelectedModal,
  addGroup,
  updateGroup,
  removeGroupInvitation,
} = GroupsSlice.actions;

export default GroupsSlice.reducer;
